const supportedLngs = ["en"]

const i18nextOptions = {
  supportedLngs,
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false }
}

export { i18nextOptions, supportedLngs }
